import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdvantagesBlock, LazyAltBasicInformationAboutProjectBlock, LazyArticlesSliderBigBlock, LazyArticlesSliderBlock, LazyBasicInformationAboutProjectBlock, LazyBlockSliderBlock, LazyBlockSliderOld, LazyButtonAgentMacroBlock, LazyCheckerboardBlock, LazyCitySelectionStubBlock, LazyCommercialCategoriesBlock, LazyConstructionProgressBlock, LazyContainerBlock, LazyCountdownTimerTrigerBlock, LazyDocumentationBlock, LazyEmployeesBlock, LazyFlatFeaturesBlock, LazyFlatFilterBlock, LazyFlatSelectorBlock, LazyFlatViewFormBlock, LazyFormMessageBigBlock, LazyGridInformationCardsBlock, LazyHistoryAnimationBlock, LazyHowToBuyBlock, LazyHowToBuySliderImagesBlock, LazyHtmlScriptBlock, LazyImageBlock, LazyInfrastructureBlock, LazyMainSliderBlock, LazyMapWithDotsBlock, LazyMessageFormBlock, LazyObjectsMapBlock, LazyOurHomesBlock, LazyPageAnchorsBlock, LazyPageHeadBlock, LazyPopularLayoutsProjectBlock, LazyMainProductCard, LazyPopularLayoutsFilters, LazyPopularPrice, LazySlideProductCard, LazyProjectConceptBlock, LazyProjectFeaturesFormsBlock, LazyQuestionAnswerBlock, LazySaleOfficesBlock, LazySelectorBlock, LazySliderImagesBlock, LazySpaceBlock, LazyStatisticsBlock, LazySubpagesBlock, LazyTextTitleImageBlock, LazyThreeDToursBlock, LazyTrustedCompanyBlock, LazyTwoColumnsBlock, LazyVisualChoiceFloorApartmentBlock, LazyWysiwygBlock, LazyPromotionCard, LazyBasicInformationPriceList, LazyBlockSliderCard, LazyBlockSliderCardBody, LazySliderCard, LazyCheckerboardTemplate, LazyHeaderNavigation, LazyPopUpInformation, LazySelectHouse, LazySelectCityDesktop, LazySelectCityMobile, LazyCommercialCardHover, LazyConstructionItem, LazyComplexCardHover, LazyPopoverDownContent, LazyBigForm, LazyHistoryCard, LazyPopupDetailed, LazyInfrastructuraControls, LazyInfrastructureMap, LazyHomeSlide, LazyIFlatBtn, LazyObjectMapOfficeCard, LazyTabCard, LazyProjectFeaturesCard, LazyProjectFeaturesPopup, LazyQuestionAnswerItem, LazySelectorCard, LazyMainLayout, LazyCmsBlockMixin, LazyCmsPage, LazyCarouselBlock, LazyCkEditorBlock, LazyGridBlock, LazyHeadingBlock, LazySectionBlock, LazySpecialBlock, LazyLayoutPlaceholder, LazyHeaderNavItem, LazyTestHeaderNav, LazyPopupGallery, LazySearchInput, LazyLazySearchDropdown, LazySearchInputBody, LazySearchInputTop, LazyArticles, LazyBrands, LazyCategories, LazyProductCard, LazyProducts, LazyService, LazyVideos, LazyComponent, LazyAddToCardBtn, LazyProductCardTemplate, LazyProductPageTemplate, LazyPagination } from '#components'
const lazyGlobalComponents = [
  ["AdvantagesBlock", LazyAdvantagesBlock],
["AltBasicInformationAboutProjectBlock", LazyAltBasicInformationAboutProjectBlock],
["ArticlesSliderBigBlock", LazyArticlesSliderBigBlock],
["ArticlesSliderBlock", LazyArticlesSliderBlock],
["BasicInformationAboutProjectBlock", LazyBasicInformationAboutProjectBlock],
["BlockSliderBlock", LazyBlockSliderBlock],
["BlockSliderOld", LazyBlockSliderOld],
["ButtonAgentMacroBlock", LazyButtonAgentMacroBlock],
["CheckerboardBlock", LazyCheckerboardBlock],
["CitySelectionStubBlock", LazyCitySelectionStubBlock],
["CommercialCategoriesBlock", LazyCommercialCategoriesBlock],
["ConstructionProgressBlock", LazyConstructionProgressBlock],
["ContainerBlock", LazyContainerBlock],
["CountdownTimerTrigerBlock", LazyCountdownTimerTrigerBlock],
["DocumentationBlock", LazyDocumentationBlock],
["EmployeesBlock", LazyEmployeesBlock],
["FlatFeaturesBlock", LazyFlatFeaturesBlock],
["FlatFilterBlock", LazyFlatFilterBlock],
["FlatSelectorBlock", LazyFlatSelectorBlock],
["FlatViewFormBlock", LazyFlatViewFormBlock],
["FormMessageBigBlock", LazyFormMessageBigBlock],
["GridInformationCardsBlock", LazyGridInformationCardsBlock],
["HistoryAnimationBlock", LazyHistoryAnimationBlock],
["HowToBuyBlock", LazyHowToBuyBlock],
["HowToBuySliderImagesBlock", LazyHowToBuySliderImagesBlock],
["HtmlScriptBlock", LazyHtmlScriptBlock],
["ImageBlock", LazyImageBlock],
["InfrastructureBlock", LazyInfrastructureBlock],
["MainSliderBlock", LazyMainSliderBlock],
["MapWithDotsBlock", LazyMapWithDotsBlock],
["MessageFormBlock", LazyMessageFormBlock],
["ObjectsMapBlock", LazyObjectsMapBlock],
["OurHomesBlock", LazyOurHomesBlock],
["PageAnchorsBlock", LazyPageAnchorsBlock],
["PageHeadBlock", LazyPageHeadBlock],
["PopularLayoutsProjectBlock", LazyPopularLayoutsProjectBlock],
["MainProductCard", LazyMainProductCard],
["PopularLayoutsFilters", LazyPopularLayoutsFilters],
["PopularPrice", LazyPopularPrice],
["SlideProductCard", LazySlideProductCard],
["ProjectConceptBlock", LazyProjectConceptBlock],
["ProjectFeaturesFormsBlock", LazyProjectFeaturesFormsBlock],
["QuestionAnswerBlock", LazyQuestionAnswerBlock],
["SaleOfficesBlock", LazySaleOfficesBlock],
["SelectorBlock", LazySelectorBlock],
["SliderImagesBlock", LazySliderImagesBlock],
["SpaceBlock", LazySpaceBlock],
["StatisticsBlock", LazyStatisticsBlock],
["SubpagesBlock", LazySubpagesBlock],
["TextTitleImageBlock", LazyTextTitleImageBlock],
["ThreeDToursBlock", LazyThreeDToursBlock],
["TrustedCompanyBlock", LazyTrustedCompanyBlock],
["TwoColumnsBlock", LazyTwoColumnsBlock],
["VisualChoiceFloorApartmentBlock", LazyVisualChoiceFloorApartmentBlock],
["WysiwygBlock", LazyWysiwygBlock],
["PromotionCard", LazyPromotionCard],
["BasicInformationPriceList", LazyBasicInformationPriceList],
["BlockSliderCard", LazyBlockSliderCard],
["BlockSliderCardBody", LazyBlockSliderCardBody],
["SliderCard", LazySliderCard],
["CheckerboardTemplate", LazyCheckerboardTemplate],
["HeaderNavigation", LazyHeaderNavigation],
["PopUpInformation", LazyPopUpInformation],
["SelectHouse", LazySelectHouse],
["SelectCityDesktop", LazySelectCityDesktop],
["SelectCityMobile", LazySelectCityMobile],
["CommercialCardHover", LazyCommercialCardHover],
["ConstructionItem", LazyConstructionItem],
["ComplexCardHover", LazyComplexCardHover],
["PopoverDownContent", LazyPopoverDownContent],
["BigForm", LazyBigForm],
["HistoryCard", LazyHistoryCard],
["PopupDetailed", LazyPopupDetailed],
["InfrastructuraControls", LazyInfrastructuraControls],
["InfrastructureMap", LazyInfrastructureMap],
["HomeSlide", LazyHomeSlide],
["IFlatBtn", LazyIFlatBtn],
["ObjectMapOfficeCard", LazyObjectMapOfficeCard],
["TabCard", LazyTabCard],
["ProjectFeaturesCard", LazyProjectFeaturesCard],
["ProjectFeaturesPopup", LazyProjectFeaturesPopup],
["QuestionAnswerItem", LazyQuestionAnswerItem],
["SelectorCard", LazySelectorCard],
["MainLayout", LazyMainLayout],
["CmsBlockMixin", LazyCmsBlockMixin],
["CmsPage", LazyCmsPage],
["CarouselBlock", LazyCarouselBlock],
["CkEditorBlock", LazyCkEditorBlock],
["GridBlock", LazyGridBlock],
["HeadingBlock", LazyHeadingBlock],
["SectionBlock", LazySectionBlock],
["SpecialBlock", LazySpecialBlock],
["LayoutPlaceholder", LazyLayoutPlaceholder],
["HeaderNavItem", LazyHeaderNavItem],
["TestHeaderNav", LazyTestHeaderNav],
["PopupGallery", LazyPopupGallery],
["SearchInput", LazySearchInput],
["LazySearchDropdown", LazyLazySearchDropdown],
["SearchInputBody", LazySearchInputBody],
["SearchInputTop", LazySearchInputTop],
["Articles", LazyArticles],
["Brands", LazyBrands],
["Categories", LazyCategories],
["ProductCard", LazyProductCard],
["Products", LazyProducts],
["Service", LazyService],
["Videos", LazyVideos],
["Component", LazyComponent],
["AddToCardBtn", LazyAddToCardBtn],
["ProductCardTemplate", LazyProductCardTemplate],
["ProductPageTemplate", LazyProductPageTemplate],
["Pagination", LazyPagination],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
